export enum InvoiceProcessStatus
{
    waiting = 0,
    success = 1,
    fullRefund = 2,
    partialRefund = 3,
    cancelled = 4
}